if (!customElements.get('launch-price-countdown')) {
  customElements.define(
    'launch-price-countdown',
    class LaunchPriceCountdown extends HTMLElement {
      connectedCallback() {
        const [datePart, timePart] = this.dataset.deadline.split('T');
        const [year, month, day] = datePart.split('-').map(Number);
        const [hours, minutes, seconds] = timePart.split(':').map(Number);

        this.deadline = new Date(year, month - 1, day, hours, minutes, seconds).getTime();
        this.build();
        this.update();
        this.timer = window.setInterval(() => this.update(), 1000);
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
      }

      build() {
        if (this.hasCountdownMarkup) return;
        if (this.querySelector('[data-unit="days"]')) {
          this.hasCountdownMarkup = true;
          return;
        }

        this.textContent = '';
        [
          ['days', 'j'],
          ['hours', 'h'],
          ['minutes', 'm'],
          ['seconds', 's'],
        ].forEach(([name, suffix]) => {
          const unit = document.createElement('span');
          unit.className = 'launch-price-countdown__unit';
          unit.dataset.unit = name;
          unit.innerHTML = `
            <span class="launch-price-countdown__window">
              <span class="launch-price-countdown__value launch-price-countdown__value--current">00</span>
            </span><span aria-hidden="true">${suffix}</span>
          `;
          this.append(unit);
        });

        this.hasCountdownMarkup = true;
      }

      setUnit(name, value) {
        const unit = this.querySelector(`[data-unit="${name}"]`);
        const valueWindow = unit.querySelector('.launch-price-countdown__window');
        const current = valueWindow.querySelector('.launch-price-countdown__value--current');

        if (!this.hasRendered) {
          current.textContent = value;
          valueWindow.style.width = `${value.length}ch`;
          return;
        }

        if (current.textContent === value) return;

        const incoming = document.createElement('span');
        incoming.className = 'launch-price-countdown__value launch-price-countdown__value--incoming';
        incoming.textContent = value;
        valueWindow.style.width = `${Math.max(current.textContent.length, value.length)}ch`;
        valueWindow.append(incoming);

        requestAnimationFrame(() => valueWindow.classList.add('is-rolling'));

        window.setTimeout(() => {
          current.remove();
          incoming.classList.replace(
            'launch-price-countdown__value--incoming',
            'launch-price-countdown__value--current'
          );
          valueWindow.classList.remove('is-rolling');
          valueWindow.style.width = `${value.length}ch`;
        }, 260);
      }

      update() {
        const remaining = this.deadline - Date.now();

        if (remaining <= 0) {
          window.clearInterval(this.timer);
          this.closest('.launch-price-badge')?.setAttribute('hidden', '');
          return;
        }

        const totalSeconds = Math.floor(remaining / 1000);
        const days = Math.floor(totalSeconds / 86400);
        const hours = Math.floor((totalSeconds % 86400) / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;
        const pad = (value) => String(value).padStart(2, '0');

        this.setUnit('days', String(days));
        this.setUnit('hours', pad(hours));
        this.setUnit('minutes', pad(minutes));
        this.setUnit('seconds', pad(seconds));
        this.setAttribute(
          'aria-label',
          `${days}j ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`
        );
        this.hasRendered = true;
      }
    }
  );
}
